import {KTIcon} from '../../../../../_metronic/helpers'
import {useState} from 'react'
import {useCart} from '../../core/cartProvider'
import {TSaleNotice} from '../Token/core/types'

export const NoticeModalSale = ({
  close,
  action,
  message = 'Esta venda depende de análise e aprovação antes de ser concluída.',
}: TSaleNotice) => {
  const reviewSalesValidated = () => {
    close()
    action()
  }

  return (
    <>
      <div className='modal fade show d-flex'>
        <div className='mx-auto mw-50 w-50 pb-10' id='validToken'>
          <div className='modal-dialog modal-dialog-centered mw 550px'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h2 className='fw-bolder'>Solicitar Aprovação</h2>
                <div
                  className='btn btn-icon btn-sm btn-active-icon-primary'
                  data-kt-users-modal-action='close'
                  onClick={() => close()}
                  style={{cursor: 'pointer'}}
                >
                  <KTIcon iconName='cross' className='fs-1' />
                </div>
              </div>
              <div>
                <h6 className='card-subtitle mt-4 mb-4 ms-5 text-align-center'>{message}</h6>
                <div className='row mb-4 px-4'>
                  <div className='col-lg-12'></div>
                </div>
              </div>
              <span className='d-flex border-bottom border-1 py-2'></span>
              <div className='col-12 mt-6 border-top-2 pb-4 px-4'>
                <div className='d-flex flex-row align-items-center justify-content-end'>
                  <button type='button' className='btn btn-secondary ' onClick={() => close()}>
                    Cancelar
                  </button>

                  <button
                    type='submit'
                    className='btn btn-danger ms-5'
                    onClick={() => reviewSalesValidated()}
                  >
                    Requisitar Análise
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}
